import { render } from "./ProcessosAnotacoesComponent.vue?vue&type=template&id=7a5b0f39&scoped=true"
import script from "./ProcessosAnotacoesComponent.vue?vue&type=script&lang=js"
export * from "./ProcessosAnotacoesComponent.vue?vue&type=script&lang=js"

import "./ProcessosAnotacoesComponent.vue?vue&type=style&index=0&id=7a5b0f39&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\Projetos TWM\\eproc\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a5b0f39"]])

export default __exports__